import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightLight,
    padding: theme.spacing(0.25, 3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
  },
  iconButton: {
    padding: '0 2px',
    color: theme.palette.text.primary,
    '&:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  iconButtonIcon: {
    width: 20,
  },
}))
